import $ from "jquery";

export const dataLayerSeats = {
	productScrollList:     [],
	dlObject:              {},
	className:             ".ssdl",
	filterRemoveAllActive: false,
	searchResults:         "",

	init: dataLayer => {
		dataLayerSeats.dlObject = dataLayer;
		dataLayerSeats.findElements( dataLayerSeats.className );
		dataLayerSeats.events();
	},

	findElements: className => {
		const dataElements = document.querySelectorAll( className );
		dataLayerSeats.elementsData( dataElements );
	},

	elementsData: dataElements => {
		if ( !dataElements || dataElements.length === 0 ) {
			return;
		}

		for ( let i = 0; i < dataElements.length; i++ ) {
			const type = dataElements[ i ].getAttribute( "data-type" );

			if ( !type || typeof dataLayerSeats.type[ type ] !== "function" ) {
				return;
			}

			dataLayerSeats.type[ type ]( dataElements[ i ] );
		}
	},
	events:       () => {
		// In viewport:
		let timer;

		$( window ).scroll( function () {
			if ( timer ) clearTimeout( timer );
			timer = setTimeout( () => {
				dataLayerSeats.sendImpressionAfterScroll();
			}, 400 );
		} );

		// Custom event because the remove button is sometimes added dynamically
		$( "body" ).on( "click", `*[data-type="remove_from_cart"]`, function () {
			dataLayerSeats.remove_from_cart( $( this ) );
		} );

		// Custom event because the checkout button is sometimes added dynamically
		$( "body" ).on( "click", '.checkout-button', function ( e ) {
			e.preventDefault();
			dataLayerSeats.checkout_button( $( this ) );
			window.location = $( this ).attr( "href" );
		} );

		$( "body" ).on( "click", '*[data-type="checkout_button"] .wc-forward', function ( e ) {
			e.preventDefault();
			dataLayerSeats.checkout_button( $( this ).parent( `*[data-type="checkout_button"]` ) );
			window.location = $( this ).attr( "href" );
		} );

		$( "body" ).on( "click", '.master_slider.ssdl', function ( e ) {
			e.preventDefault();

			dataLayerSeats.type.promotion_click( $( this ) );

			window.location = e.target.href;
		} );

	},

	sendImpressionAfterScroll: () => {
		const dataElements = document.querySelectorAll( dataLayerSeats.className );

		if ( dataElements.length > 0 ) {
			const impressionList = [];

			for ( let t = 0; t < dataElements.length; t++ ) {
				const element = dataElements[ t ];

				if ( element.getAttribute( "data-type" ) === "product_list" ) {
					if ( dataLayerSeats.inViewPort( element ) ) {
						const is_woocommerce = element.getAttribute( "data-woocommerce" ) === "true",
						      id             = element.getAttribute( "data-id" ).toString(),
						      name           = element.getAttribute( "data-name" ),
						      price          = element.getAttribute( "data-price" ),
						      category       = element.getAttribute( "data-category" ),
						      list           = element.getAttribute( "data-list" ),
						      position       = element.getAttribute( "data-position" );

						if ( !dataLayerSeats.productScrollList[ id ] ) {
							if ( !id || !name || !price || !category || !list || !position ) {
								return;
							}

							dataLayerSeats.productScrollList[ id ] = 1;

							const product_data = {
								"name":     name,
								"id":       id,
								"price":    parseFloat( price ),
								"brand":    "Seats and Sofas",
								"category": category,
								"list":     list,
								"position": parseInt( position )
							};

							if ( is_woocommerce ) {
								product_data[ "variant" ]            = "";
								product_data[ "product_dimensions" ] = "";
								product_data[ "product_color" ]      = "";
							}

							impressionList.push( product_data );
						}
					}
				}
			}

			// push en reset items
			if ( impressionList.length > 0 ) {
				dataLayerSeats.dataLayer.push( { "ecommerce": { "impressions": impressionList }, "event": "ecomProductImpressions" } );
			}
		}
	},

	/**
	 * Datalayer event: remove product from cart
	 *
	 * @param element
	 */
	remove_from_cart: element => {
		const name     = element.data( "name" ),
		      id       = element.data( "id" ).toString(),
		      price    = element.data( "price" ),
		      category = element.data( "category" ),
		      quantity = element.data( "quantity" );

		if ( !name || !id || !price || !category || !quantity ) {
			return;
		}

		dataLayerSeats.dataLayer.push( {
			"ecommerce": {
				"remove": {
					"products": [ {
						"name":               name,
						"id":                 id,
						"price":              parseFloat( price ),
						"brand":              "Seats and Sofas",
						"category":           category,
						"variant":            "",
						"product_dimensions": "",
						"product_color":      "",
						"quantity":           quantity
					} ]
				}
			},
			"event":     "ecomRemoveFromCart"
		} );
	},

	checkout_button: element => {
		const ids        = element.data( "ids" ),
		      names      = element.data( "names" ),
		      prices     = element.data( "prices" ),
		      categories = element.data( "categories" ),
		      quantities = element.data( "quantities" );

		if ( Array.isArray( ids ) && Array.isArray( names ) && Array.isArray( prices ) && Array.isArray( categories ) && Array.isArray( quantities ) ) {
			const products = [];

			ids.forEach( ( item, i ) => {
				products.push( {
					"name":               names[ i ],
					"id":                 item.toString(),
					"price":              parseFloat( prices[ i ] ),
					"brand":              "Seats and Sofas",
					"category":           categories[ i ],
					"variant":            "",
					"product_dimensions": "",
					"product_color":      "",
					"quantity":           quantities[ i ],
				} );
			} );

			dataLayerSeats.dataLayer.push( {
				"ecommerce":    {
					"checkout": {
						"actionField": { "step": 1 },
						products,
					}
				},
				"event":        "ecomCheckout",
				"eventTimeout": 2000
			} );
		}
	},

	type: {
		/**
		 * Standard click events
		 *
		 * @param element
		 */
		datalayer_general: element => {
			$( element ).click( function () {
				const label    = element.getAttribute( "data-label" ),
				      category = element.getAttribute( "data-category" ),
				      action   = element.getAttribute( "data-action" );

				let datalayerEvent = element.getAttribute( "data-event" );

				if (
					label !== undefined && label.length > 0 &&
					category !== undefined && category.length > 0 &&
					action !== undefined && action.length > 0 &&
					element.classList.contains( "closed" ) !== true
				) {
					if ( datalayerEvent === undefined || datalayerEvent === null ) {
						datalayerEvent = "eventPush";
					}

					const event = dataLayerSeats.dataLayer.event( category, action, label, datalayerEvent );
					dataLayerSeats.dataLayer.push( event );
				}
			} );
		},

		/**
		 * Offer page click events
		 *
		 * @param element
		 */
		offer_click: element => {
			$( element ).click( function () {
				const label        = element.getAttribute( "data-label" ),
				      category     = element.getAttribute( "data-category" ),
				      action       = element.getAttribute( "data-action" ),
				      product_id   = element.getAttribute( "data-id" ),
				      event_name   = element.getAttribute( "data-event" ),
				      product_name = element.getAttribute( "data-name" );

				if ( label !== undefined && label.length > 0 && category !== undefined && category.length > 0 && action !== undefined && action.length > 0 && product_id !== undefined && product_id.length > 0 && event_name !== undefined && event_name.length > 0 && product_name !== undefined && product_name.length > 0 ) {
					const event = dataLayerSeats.dataLayer.event( category, action, label, event_name, "undefined", false, undefined, undefined, product_id, product_name );
					dataLayerSeats.dataLayer.push( event );
				}
			} );
		},

		megastore_click: element => {
			$( element ).click( function () {
				const category = element.getAttribute( "data-category" ),
				      city     = element.getAttribute( "data-city" ),
				      province = element.getAttribute( "data-province" ),
				      action   = element.getAttribute( "data-action" );

				if ( category !== undefined && category.length > 0 && city !== undefined && city.length > 0 && province !== undefined && province.length > 0 && action !== undefined && action.length > 0 ) {
					const event = dataLayerSeats.dataLayer.event( category, action, "storeProvince:" + province + " || storeCity:" + city, "megaStore", "undefined", false, province, city );
					dataLayerSeats.dataLayer.push( event );
				}
			} );
		},

		filter_add: element => {
			$( element ).click( function () {
				let filter_value = element.innerText;

				const filter_category = element.getAttribute( "data-filtercat" ),
				      filter_amount   = filter_value.substring(
					      filter_value.indexOf( "(" ) + 1,
					      filter_value.lastIndexOf( ")" )
				      );

				filter_value = filter_value.replace( "(" + filter_amount + ")", "", filter_value );

				if ( filter_category !== undefined && filter_value !== undefined ) {
					const event = dataLayerSeats.dataLayer.event( "filter", "enable filter", "filterCat:" + filter_category.toUpperCase() + " || filter:" + filter_value, "eventPush" );
					dataLayerSeats.dataLayer.push( event );
				}
			} );
		},

		filter_remove: element => {
			$( element ).click( function () {
				dataLayerSeats.type.filter_remove_event( element );
			} );
		},

		filter_remove_event: element => {
			const filter_category = element.getAttribute( "data-filtercat" );

			let filter_value = element.innerText;

			filter_value = filter_value.substring( 0, filter_value.indexOf( " (" ) );

			if ( filter_value === "" ) {
				filter_value = element.getAttribute( "data-name" );
			}

			if ( filter_category !== undefined && filter_value !== undefined ) {
				const event = dataLayerSeats.dataLayer.event( "filter", "disable filter", "filterCat:" + filter_category + " || filter:" + filter_value, "eventPush" );
				dataLayerSeats.dataLayer.push( event );
			}
		},

		filter_remove_all: element => {
			if ( dataLayerSeats.filterRemoveAllActive === false ) {
				dataLayerSeats.filterRemoveAllActive = true;

				$( element ).click( function () {
					const event = dataLayerSeats.dataLayer.event( "filter", "disable all filters", undefined, "eventPush" );
					dataLayerSeats.dataLayer.push( event );
				} );
			}
		},

		send_newsletter: () => {
			const event = dataLayerSeats.dataLayer.event( "form submit", "newsletter signup", seats.current_path, "formSubmit", undefined, false );
			dataLayerSeats.dataLayer.push( event );
		},

		/**
		 * Datalayer event: add a product to wishlist
		 *
		 * @param label
		 * @param id
		 */
		wishlist_add: ( label, id ) => {
			if ( !label || !id ) {
				return;
			}

			dataLayerSeats.dataLayer.push( {
				"eventCategory":       "wishlist",
				"eventAction":         "add to wishlist",
				"eventLabel":          `productName:${label}`,
				"eventValue":          undefined,
				"eventNonInteraction": false,
				"productName":         label,
				"productID":           String( id ),
				"event":               "addToWishlist"
			} );
		},

		/**
		 * Datalayer event: remove a product from wishlist
		 *
		 * @param label
		 * @param id
		 */
		wishlist_remove: ( label, id ) => {
			if ( !label || !id ) {
				return;
			}

			dataLayerSeats.dataLayer.push( {
				"eventCategory":       "wishlist",
				"eventAction":         "remove from wishlist",
				"eventLabel":          `productName:${label}`,
				"eventValue":          undefined,
				"eventNonInteraction": false,
				"productName":         label,
				"productID":           String( id ),
				"event":               "removeFromWishlist"
			} );
		},

		/**
		 * All datalayer elements that need to be send without clicks
		 *
		 * @param element
		 */
		send_megastore: element => {
			const event = dataLayerSeats.dataLayer.event( "megastores", "find your megastore", "undefined", "megaStore" );
			dataLayerSeats.dataLayer.push( event );
		},

		send_searchresults: function ( element ) {
			const label    = element.getAttribute( "data-label" ),
			      category = element.getAttribute( "data-category" ),
			      action   = element.getAttribute( "data-action" );

			if ( label !== undefined && label.length > 0 && category !== undefined && category.length > 0 && action !== undefined && action.length > 0 && dataLayerSeats.searchResults !== label ) {
				dataLayerSeats.searchResults = label;
				const event                  = dataLayerSeats.dataLayer.event( category, action, label, "eventPush" );
				dataLayerSeats.dataLayer.push( event );
			}
		},

		send_megastore_maps: element => {
			const category = element.getAttribute( "data-category" ),
			      city     = element.getAttribute( "data-city" ),
			      province = element.getAttribute( "data-province" ),
			      action   = element.getAttribute( "data-action" );

			if ( category !== undefined && category.length > 0 && city !== undefined && city.length > 0 && province !== undefined && province.length > 0 && action !== undefined && action.length > 0 ) {
				const event = dataLayerSeats.dataLayer.event( category, action, "storeProvince:" + province + " || storeCity:" + city, "megaStore", "undefined", false, province, city );
				dataLayerSeats.dataLayer.push( event );
			}
		},

		send_megastore_appointment: element => {
			const category = element.getAttribute( "data-category" ),
			      city     = element.getAttribute( "data-city" ),
			      province = element.getAttribute( "data-province" ),
			      action   = element.getAttribute( "data-action" );

			if ( category !== undefined && category.length > 0 && city !== undefined && city.length > 0 && province !== undefined && province.length > 0 && action !== undefined && action.length > 0 ) {
				const event = dataLayerSeats.dataLayer.event( category, action, "storeProvince:" + province + " || storeCity:" + city, "megaStore", "undefined", false, province, city );
				dataLayerSeats.dataLayer.push( event );
			}
		},

		send_contactform: element => {
			const category     = element.getAttribute( "data-category" ),
			      action       = element.getAttribute( "data-action" ),
			      label        = element.getAttribute( "data-label" ),
			      event_name   = element.getAttribute( "data-event" ),
			      event_value  = element.getAttribute( "data-value" ),
			      product_name = element.getAttribute( "data-product-name" ),
			      product_id   = element.getAttribute( "data-product-id" );

			if ( category !== undefined && category.length > 0 && action !== undefined && action.length > 0 && label !== undefined && label.length > 0 && event_name !== undefined && event_name.length > 0 ) {
				const event = dataLayerSeats.dataLayer.event( category, action, label, event_name, event_value, false, undefined, undefined, product_id, product_name );
				dataLayerSeats.dataLayer.push( event );
			}
		},

		/**
		 * E-commerce datalayer
		 *
		 * @param element
		 */
		product_detail: element => {
			const is_woocommerce = element.getAttribute( "data-woocommerce" ) === "true",
			      name           = element.getAttribute( "data-name" ),
			      id             = element.getAttribute( "data-id" ).toString(),
			      price          = element.getAttribute( "data-price" ),
			      category       = element.getAttribute( "data-category" );

			if ( !name || !id || !price || !category ) {
				return;
			}

			const product_data = {
				"name":     name,
				"id":       id,
				"price":    parseFloat( price ),
				"brand":    "Seats and Sofas",
				"category": category
			};

			if ( is_woocommerce ) {
				product_data[ "variant" ]            = "";
				product_data[ "product_dimensions" ] = "";
				product_data[ "product_color" ]      = "";
			}

			dataLayerSeats.dataLayer.push( {
				"ecommerce": {
					"detail": {
						"actionField": {},
						"products":    [ product_data ]
					}
				},
				"event":     "ecomProductDetailPage"
			} );
		},

		product_list: element => {
			const id = element.getAttribute( "data-id" );

			$( "body" ).on( "click", "*[data-type=\"product_list\"][data-id=\"" + id + "\"]", function ( e ) {
				const is_woocommerce = element.getAttribute( "data-woocommerce" ) === "true";

				if ( !is_woocommerce && window.google_tag_manager && window.ga && ga.create ) {
					e.preventDefault();
				}

				const id       = element.getAttribute( "data-id" ).toString(),
				      name     = element.getAttribute( "data-name" ),
				      price    = element.getAttribute( "data-price" ),
				      category = element.getAttribute( "data-category" ),
				      list     = element.getAttribute( "data-list" ),
				      position = element.getAttribute( "data-position" );

				let product_link = $( element ).attr( "href" );

				if ( !name || !id || !price || !category || !list || !position ) {
					return;
				}

				const product_data = {
					"name":     name,
					"id":       id,
					"price":    parseFloat( price ),
					"brand":    "Seats and Sofas",
					"category": category,
					"position": parseInt( position )
				};

				if ( is_woocommerce ) {
					product_data[ "variant" ]            = "";
					product_data[ "product_dimensions" ] = "";
					product_data[ "product_color" ]      = "";
					product_link                         = $( element ).find( "a" ).first().attr( "href" );
				}

				dataLayerSeats.dataLayer.push( {
					"ecommerce":     {
						"click": {
							"actionField": { "list": list },
							"products":    [ product_data ]
						}
					},
					"event":         "ecomProductClick",
					"eventCallback": () => {
						window.location = product_link;
					},
					"eventTimeout":  2000
				} );
			} );
		},

		promotion_view: element => {
			const name = element.getAttribute( "data-name" ) ?? "",
			      id   = element.getAttribute( "data-id" ) ?? "";

			dataLayerSeats.dataLayer.push( {
				"ecommerce": {
					"promoView": {
						"promotions": [ {
							"name": name,
							"id":   String( id ),
						} ]
					}
				},
				"event":     "ecomPromoView",
			} );
		},

		promotion_click: element => {
			const name = element.data( "name" ) ?? "",
			      id   = element.data( "id" ) ?? "";

			dataLayerSeats.dataLayer.push( {
				"ecommerce": {
					"promoClick": {
						"promotions": [ {
							"name": name,
							"id":   String( id ),
						} ]
					}
				},
				"event":     "ecomPromoClick",
			} );
		},

		/**
		 * Datalayer event: add items to the cart,
		 * this will work for adding an item on the product single and adding an item in any product list
		 *
		 * @param element
		 */
		add_to_cart: element => {
			$( element ).click( function () {
				const name     = element.getAttribute( "data-name" ),
				      id       = element.getAttribute( "data-id" ).toString(),
				      price    = element.getAttribute( "data-price" ),
				      category = element.getAttribute( "data-category" ),
				      quantity = $( element ).prev().find( "input" ).val() ?? $( element ).find( ".add_to_cart_button" ).data( "quantity" );

				if ( !name || !id || !price || !category || !quantity ) {
					return;
				}

				dataLayerSeats.dataLayer.push( {
					"ecommerce": {
						"add": {
							"products": [ {
								"name":               name,
								"id":                 id,
								"price":              parseFloat( price ),
								"brand":              "Seats and Sofas",
								"category":           category,
								"variant":            "",
								"product_dimensions": "",
								"product_color":      "",
								"quantity":           parseInt( quantity )
							} ]
						}
					},
					"event":     "ecomAddToCart",
				} );
			} );
		},

		order_complete: element => {
			const id         = element.getAttribute( "data-id" ),
			      revenue    = element.getAttribute( "data-revenue" ),
			      tax        = element.getAttribute( "data-tax" ),
			      shipping   = element.getAttribute( "data-shipping" ),
			      coupon     = element.getAttribute( "data-coupon" ),
			      ids        = JSON.parse( element.getAttribute( "data-ids" ) ),
			      names      = JSON.parse( element.getAttribute( "data-names" ) ),
			      prices     = JSON.parse( element.getAttribute( "data-prices" ) ),
			      categories = JSON.parse( element.getAttribute( "data-categories" ) ),
			      quantities = JSON.parse( element.getAttribute( "data-quantities" ) ),
			      coupons    = JSON.parse( element.getAttribute( "data-coupons" ) );

			if ( id && revenue && tax && shipping && Array.isArray( ids ) && Array.isArray( names ) && Array.isArray( prices ) && Array.isArray( categories ) && Array.isArray( quantities ) && Array.isArray( coupons ) ) {
				const products = [];

				ids.forEach( ( item, i ) => {
					products.push( {
						"name":               names[ i ],
						"id":                 item.toString(),
						"price":              parseFloat( prices[ i ] ),
						"brand":              "Seats and Sofas",
						"category":           categories[ i ],
						"variant":            "",
						"product_dimensions": "",
						"product_color":      "",
						"quantity":           quantities[ i ],
						"coupons":            coupons[ i ],
					} );
				} );

				dataLayerSeats.dataLayer.push( {
					"ecommerce": {
						"purchase": {
							"actionField": {
								"id":       id,
								"revenue":  revenue,
								"tax":      tax,
								"shipping": shipping,
								"coupon":   coupon ?? "",
							},
							products,
						}
					},
					"event":     "ecomPurchase"
				} );
			}
		}
	},

	inViewPort: elem => {
		const bounding = elem.getBoundingClientRect();

		return (
			bounding.top >= 0 &&
			bounding.left >= 0 &&
			bounding.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) &&
			bounding.right <= ( window.innerWidth || document.documentElement.clientWidth )
		);
	},

	dataLayer: {
		push: object => {
			dataLayerSeats.dlObject.push( object );
		},

		event: ( category, action, label, event, value, nonInteractive, province, city, product_id, productName ) => {
			product_id     = product_id || undefined;
			productName    = productName || undefined;
			value          = value || "undefined";
			province       = province || undefined;
			city           = city || undefined;
			nonInteractive = nonInteractive || false;

			return {
				"eventCategory":       category,
				"eventAction":         action,
				"eventLabel":          label,
				"eventValue":          value,
				"eventNonInteraction": nonInteractive,
				"productName":         productName,
				"productID":           String( product_id ),
				"storeProvince":       province,
				"storeCity":           city,
				"event":               event
			};
		}
	}
};

$( document ).ready( function () {
	// Check if GTM script is loaded.
	if ( typeof dataLayer === "object" ) {
		dataLayerSeats.init( dataLayer );
	}

	// Triggers when facet-wp wp reloads
	$( document ).on( "facetwp-loaded", function () {
		dataLayerSeats.findElements( ".collection__filter-wrapper " + dataLayerSeats.className );
		dataLayerSeats.findElements( ".search__content " + dataLayerSeats.className );
	} );

	// Code to be trigger when gform confirmation page is loaded
	$( document ).on( "gform_confirmation_loaded", function ( event, formId ) {
		dataLayerSeats.findElements( ".datalayer_form" );

		if ( formId === parseInt( seats.newsletter_form ) ) {
			dataLayerSeats.type.send_newsletter();
		}
	} );
} );